import { BaseRestDataProvider } from './BaseRestDataProvider';
import { CareerLevelRate } from '../models/CareerLevelRate';

export class CareerLevelRatesRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/careerlevelrates');
  }

  getAll(): Promise<CareerLevelRate[]> {
    return this.get<CareerLevelRate[]>(``);
  }

  getById(id: string): Promise<CareerLevelRate> {
    return this.get<CareerLevelRate>(`/${id}`);
  }

  add(rate: CareerLevelRate): Promise<void> {
    return this.post<void>(``, rate);
  }

  update(id: string, rate: CareerLevelRate): Promise<void> {
    return this.put<void>(`/${id}`, rate);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { CareerLevelRate };
